export default __webpack_public_path__ + "static/img/pic1@2x.4bca6f.png";